import { Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import { FloatingContact, ScrollToTop } from './components/Shared';
import Home from './pages/Home';
import Collections from './pages/Collections';
import CollectionDetail from './pages/CollectionDetail';
import Lookbook from './pages/Lookbook';
import Heritage from './pages/Heritage';
import Visit from './pages/Visit';
import Runway from './pages/Runway';
import { PrivacyPolicy, TermsAndConditions } from './pages/Legal';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <div className="flex min-h-screen flex-col">
      <ScrollToTop />

      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100]
          focus:bg-royal-800 focus:px-5 focus:py-3 focus:text-[11px] focus:uppercase
          focus:tracking-wide2 focus:text-cream-50"
      >
        Skip to content
      </a>

      <Header />

      <main id="main" className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/collections" element={<Collections />} />
          <Route path="/collections/:slug" element={<CollectionDetail />} />
          <Route path="/lookbook" element={<Lookbook />} />
          <Route path="/runway" element={<Runway />} />
          <Route path="/heritage" element={<Heritage />} />
          <Route path="/visit" element={<Visit />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <Footer />
      <FloatingContact />
    </div>
  );
}
